export default "__VITE_ASSET__DRc7hWzr__"